export enum CampaignType {
  PROGRAMMATIC = 'PROGRAMMATIC',
  DIRECT = 'DIRECT',
}

export type TargetKey = 'budget' | 'frames' | 'impressions';

type TargetCriteriaKey = 'budgetCriteria' | 'framesCriteria' | 'impressionsCriteria';

export const TARGET_KEY_TO_TARGET_CRITERIA_KEY_MAPPING: Record<TargetKey, TargetCriteriaKey> = {
  budget: 'budgetCriteria',
  frames: 'framesCriteria',
  impressions: 'impressionsCriteria',
};
